import { css } from "styled-components";

export const Typography = {
   h1: css`
      font-size: 25px;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: #000;
   `,
   h2: css`
      font-size: 24px;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: #000;
      overflow-wrap: break-word;
      word-break: keep-all;
   `,
   h3: css`
      font-size: 22px;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: #000;
      overflow-wrap: break-word;
      word-break: keep-all;
   `,
   h4: css`
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.01em;
      color: #000;
      overflow-wrap: break-word;
      word-break: keep-all;
   `,
   subtitle1: css`
      font-size: 13px;
      letter-spacing: -0.02em;
      color: #000;
   `,
   description1: css`
      font-size: 18px;
      letter-spacing: -0.03em;
      color: #000;
   `,
   description1XS: css`
      font-size: 17px;
      color: #000;
      letter-spacing: -0.03em;
   `,
   description2: css`
      font-size: 15px;
      letter-spacing: -0.02em;
      color: #000;
   `,
};
